import { render, staticRenderFns } from "./FAccountTransactionAmount.vue?vue&type=template&id=00f07224&"
import script from "./FAccountTransactionAmount.vue?vue&type=script&lang=js&"
export * from "./FAccountTransactionAmount.vue?vue&type=script&lang=js&"
import style0 from "./FAccountTransactionAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports